/** Stable product line shown in UI (corner badge, login, legal modal, mobile footer). */
export const APP_VERSION_LABEL = '3.1';
